export default "__VITE_ASSET__fa28a691__"